<template>
    <div class="page-payment">
        <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'วิธีการชำระเงิน - ProbPlus', 
                'Payment Method - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'ค่าลงทะเบียนเรียนรวมค่าสอบวัดผลครั้งแรก (ภาษาไทย) 1,000 บาท',
                'Price for attending course and exam (English Course) 2,500 Baht')" />
        <ContentLoader :isDisplay="!contentReady" />
        <div class="container" v-if="contentReady">
            <div class="box">
                <div class="top-title">
                    <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'การชำระเงิน', 'Payment') }}</h1>
                    <div class="confirm">
                        <button class="no-paid" @click="showConfirmPayment()" v-if="fields.paymentStatus == $PPlusConstant.PaymentStatus_None || fields.paymentStatus == $PPlusConstant.PaymentStatus_NeedPayExam">{{ $PPlusEngine.getDictionary($route.params.lang, 'กดเพื่อส่งหลักฐานการโอน', 'Click for Sending Transfer Slip') }}</button>
                        <span class="waiting" v-if="fields.paymentStatus == $PPlusConstant.PaymentStatus_WaitForConfirm">{{ $PPlusEngine.getDictionary($route.params.lang, 'รอตรวจสอบการชำระเงิน', 'In Progress of Reviewing') }}</span>
                        <span class="paid" v-if="fields.paymentStatus == $PPlusConstant.PaymentStatus_Paid">{{ $PPlusEngine.getDictionary($route.params.lang, 'ชำระเงินเรียบร้อยแล้ว', 'Payment Completed') }}</span>
                    </div>
                </div>
                <article>
                    <h2><span><font-awesome-icon :icon="['fas', 'credit-card']" /></span> {{ $PPlusEngine.getDictionary($route.params.lang, 'ข้อมูลการชำระเงิน', 'Price Information') }}</h2>
                    <section>
                        <div class="amount">
                            <label><i class="pe-7s-angle-right"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'ตารางค่าใช้จ่าย', 'Pricing') }}</label>
                            <table class="table">
                                <tr>
                                    <td>{{ $PPlusEngine.getDictionary($route.params.lang, 'ค่าลงทะเบียนเรียนรวมค่าสอบวัดผล (คอร์สภาษาไทย)', 'Price for attending course and exam (Thai Course)') }}</td>
                                    <td><span>1,000</span> ฿</td>
                                </tr>
                                <tr>
                                    <td>{{ $PPlusEngine.getDictionary($route.params.lang, 'ค่าลงทะเบียนเรียนรวมค่าสอบวัดผล (คอร์สภาษาอังกฤษ)', 'Price for attending course and exam (English Course)') }}</td>
                                    <td><span>2,500</span> ฿</td>
                                </tr>
                                <tr>
                                    <td>{{ $PPlusEngine.getDictionary($route.params.lang, 'กรณีสอบครั้งแรกแล้วไม่ผ่าน ผู้เรียนสามารถสอบใหม่ได้อีก 1 ครั้งฟรี แต่กรณีสอบไม่ผ่านครั้งต่อไป ต้องทำการชำระค่าเข้าสอบ', 'In case that the trainee failed on their first examination, they can retake the exam one more time for free. Otherwise, there will be THB 500 fee each time to take another exam') }}</td>
                                    <td><span>500</span> ฿</td>
                                </tr>
                                <tr>
                                    <td>{{ $PPlusEngine.getDictionary($route.params.lang, 'สำหรับกลุ่มลูกค้ารายสถาบัน', 'For group customer, institute, or company') }}</td>
                                    <td>{{ $PPlusEngine.getDictionary($route.params.lang, 'กรุณาติดต่อมาที่', 'Please send us a message via ') }} <router-link :to="'/' + $route.params.lang + '/contact'">{{ $PPlusEngine.getDictionary($route.params.lang, 'หน้าติดต่อเรา', 'Contact Us') }}</router-link></td>
                                </tr>
                            </table>
                        </div>
                        <template v-if="$route.params.lang == 'th'">
                            <p>* กรุณาลงทะเบียนหรือเข้าสู่ระบบก่อนทำการชำระเงิน</p>
                            <p>* การชำระค่าบริการสามารถทำได้ 1 คนต่อ 1 บัญชีใช้งาน</p>
                            <p>* ตรวจสอบราคาของหลักสูครภาษาในคอร์สที่เลือก เพื่อชำระได้อย่างถูกต้อง</p>
                            <p>* ท่านสามารถทำการโอนเงินผ่านธนาคารในประเทศไทย ทั้งนี้ในกรณีที่ท่านทำการโอนเงินและมีค่าธรรมเนียมจากทางธนาคาร ท่านต้องเป็นผู้รับผิดชอบค่าธรรมเนียมในการโอนเงิน</p>
                        </template>
                        <template v-if="$route.params.lang == 'en'">
                            <p>* Please register your account and sign in to the website before making payment</p>
                            <p>* Payment can be done per 1 account</p>
                            <p>* Make sure you have done checking course language price before transfer</p>
                            <p>* You can transfer your payment via all banks in Thailand. In case, there is any transfer fees, you must be the one who pay for the transferring fees</p>
                        </template>
                    </section>

                    <h2><span><font-awesome-icon :icon="['fas', 'list']" /></span> {{ $PPlusEngine.getDictionary($route.params.lang, 'ช่องทางการชำระเงิน', 'Payment Channel') }}</h2>
                    <section>
                        <div class="bank">
                            <h4><i class="pe-7s-angle-down"></i> {{ $PPlusEngine.getDictionary($route.params.lang, 'โอนเงินผ่านทางเคาน์เตอร์ธนาคาร / ATM / อินเทอร์เนต', 'Transfer via Bank / ATM / Internet Banking') }}</h4>
                            <div class="item">
                                <img src="@/assets/icon-bank-krungsri.png" alt="Krungsri Bank" title="Krungsri Bank" />
                                <label>
                                    <span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ธนาคาร', 'Bank Name') }}</span>
                                    {{ $PPlusEngine.getDictionary($route.params.lang, 'ธนาคารกรุงศรี', 'Bank of Ayudhya') }}
                                </label>
                                <label>
                                    <span>{{ $PPlusEngine.getDictionary($route.params.lang, 'เลขที่บัญชี', 'Account No.') }}</span>
                                    677-108809-1
                                </label>
                                <label>
                                    <span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อบัญชี', 'Account Name') }}</span>
                                    {{ $PPlusEngine.getDictionary($route.params.lang, 'บริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด', 'Professional be Positive Co., Ltd.') }}
                                </label>
                            </div>
                            <!-- <h4><i class="pe-7s-angle-down"></i> QR Scan Mobile Banking</h4>
                            <div class="item">
                                <img src="@/assets/icon-bank-qr.png" alt="QR Code" title="QR Code" />
                                <label>
                                    <span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ธนาคาร', 'Bank Name') }}</span>
                                    {{ $PPlusEngine.getDictionary($route.params.lang, 'ธนาคารกรุงศรี', 'Bank of Ayudhya') }}
                                </label>
                                <label>
                                    <span>{{ $PPlusEngine.getDictionary($route.params.lang, 'หมายเลขพร้อมเพย์', 'Promptpay Number') }}</span>
                                    0656176123
                                </label>
                                <label>
                                    <span>{{ $PPlusEngine.getDictionary($route.params.lang, 'ชื่อบัญชี', 'Account Name') }}</span>
                                    {{ $PPlusEngine.getDictionary($route.params.lang, 'บริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด', 'Professional be Positive Co., Ltd.') }}
                                </label>
                            </div> -->
                        </div>
                        <template v-if="$route.params.lang == 'th'">
                            <p>* โปรดเก็บหลักฐานการโอนเงินของท่านไว้ยืนยันการชำระเงินด้วย</p>
                        </template>
                        <template v-if="$route.params.lang == 'en'">
                            <p>* Please keep your transfer slip for your confirm payment</p>
                        </template>
                    </section>

                    <h2><span><font-awesome-icon :icon="['fas', 'calendar-check']" /></span> {{ $PPlusEngine.getDictionary($route.params.lang, 'การแจ้งชำระเงิน', 'Confirm Payment') }}</h2>
                    <section>
                        <div>{{ $PPlusEngine.getDictionary($route.params.lang, 
                                'หลังจากทำการโอนเงินเสร็จแล้ว โปรดนำหลักฐานการโอนเงินมายืนยันการชำระเงิน', 
                                'Payment Information') }}</div>
                        <div class="confirm">
                            <button class="no-paid" @click="showConfirmPayment()" v-if="fields.paymentStatus == $PPlusConstant.PaymentStatus_None || fields.paymentStatus == $PPlusConstant.PaymentStatus_NeedPayExam">{{ $PPlusEngine.getDictionary($route.params.lang, 'กดเพื่อส่งหลักฐานการโอน', 'Click for Sending Transfer Slip') }}</button>
                            <span class="waiting" v-if="fields.paymentStatus == $PPlusConstant.PaymentStatus_WaitForConfirm">{{ $PPlusEngine.getDictionary($route.params.lang, 'รอตรวจสอบการชำระเงิน', 'In Progress of Reviewing') }}</span>
                            <span class="paid" v-if="fields.paymentStatus == $PPlusConstant.PaymentStatus_Paid">{{ $PPlusEngine.getDictionary($route.params.lang, 'ชำระเงินเรียบร้อยแล้ว', 'Payment Completed') }}</span>
                        </div>
                        <template v-if="$route.params.lang == 'th'">
                            <p>* ท่านสามารถแจ้งขอรับใบเสร็จได้ในแบบฟอร์มการส่งหลักฐานการชำระเงิน</p>
                            <p>* หลังจากการแจ้งชำระเงิน จะมีขั้นตอนการยืนยันความถูกต้องภายใน 1-2 ชั่วโมง โดยจะมีการแจ้งกลับไปทางอีเมล</p>
                            <p>* เมื่อบัญชีของท่านได้รับการยืนยันแล้ว บัญชีของท่านจะมีอายุการใช้งานสำหรับเข้าเรียนและสอบวัดผลได้ภายใน 1 ปี</p>
                        </template>
                        <template v-if="$route.params.lang == 'en'">
                            <p>* You can request for the receipt at confirm payment form</p>
                            <p>* After completed your payment, we will validate and confirm your payument via the email</p>
                            <p>* Once your account has been approved, your account will be active for attending the course and take the exam within a year</p>
                        </template>
                    </section>
                </article>
            </div>
        </div>

        <ModalConfirmPayment :isDisplay="isShowConfirmPayment" @hideConfirmPayment="hideConfirmPayment" />
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import ModalConfirmPayment from '@/components/Modal/ConfirmPayment';
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    components: {
        ContentLoader,
        ModalConfirmPayment
    },
    data() {
        return {
            contentReady: false,
            fields: {},
            isShowConfirmPayment: false
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/payment/get-content', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.fields = response.data;
                this.contentReady = true;
            });
        },
        showConfirmPayment() {
            let loader = this.$WeHelper.modalLoad();
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};
            
            this.$WeHelper.postAPI(apiURL, '/api/user/authen-user', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                    if (response.data.user.isAuthen) {
                        this.isShowConfirmPayment = true;
                    }
                    else {
                        this.alertPleaseLogin();
                    }

                    loader.hide();
                }
            });
        },
        hideConfirmPayment(value) {
            if (!this.$WeHelper.isNullOrEmpty(value)) {
                this.fields.paymentStatus = value.status;
            }

            this.isShowConfirmPayment = false;
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-payment {
    padding: 50px 0;

    @media only screen and (max-width: $screenSmall) {
        padding: 30px 0;
    }

    .box {
        background: #fff;

        .top-title {
            position: relative;
            background-image: url(../assets/payment-bg.jpg);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            height: 200px;

            h1 {
                margin: 0;
                padding: 30px 0 0 40px;
                font-size: 34px;
                font-weight: 200;
                color: #fff;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);

                &:after {
                    content: " ";
                    display: block;
                    width: 70px;
                    height: 1px;
                    background: #fff;
                    margin-top: 15px;
                }
            }

            .confirm {
                position: absolute;
                bottom: 40px;
                left: 40px;
                margin: 0;
            }
        }

        .confirm {
            margin: 15px 0;

            button, span {
                color: #fff;
                text-align: center;
                border: 1px none;
                padding: 12px;
                font-size: 14px;

                &.no-paid {
                    background: #cc0000;
                }

                &.waiting {
                    background: #eab64e;
                }

                &.paid {
                    background: #3ebfa1;
                }
            }
        }

        article {
            position: relative;
            overflow: hidden;
            padding: 30px;

            @media only screen and (max-width: $screenSmall) {
                padding: 20px;
            }

            .paper {
                padding: 30px;
                border: 1px solid #ddd;

                @media only screen and (max-width: $screenSmall) {
                    padding: 20px;
                }
            }

            h2 {
                font-size: 22px;
                color: #333;
                letter-spacing: -1px;
                padding-top: 20px;
                margin-top: 30px;
                border-top: 1px solid #ddd;

                &:first-child {
                    padding-top: 0;
                    margin-top: 0;
                    border-top: none;
                }

                @media only screen and (max-width: $screenSmall) {
                    font-size: 20px;
                }

                span {
                    width: 40px;
                    height: 40px;
                    background: #666;
                    color: #fff;
                    text-align: center;
                    margin-right: 10px;
                    padding-top: 4px;
                    @include verticalAlign(middle);
                    @include borderRadius(1000px);

                    @media only screen and (max-width: $screenSmall) {
                        width: 30px;
                        height: 30px;
                        padding-top: 0;
                    }
                }

                svg {
                    font-size: 16px;

                    @media only screen and (max-width: $screenSmall) {
                        font-size: 13px;
                    }
                }
            }

            section {
                padding-left: 55px;

                @media only screen and (max-width: $screenSmall) {
                    padding-left: 0;
                }

                .amount {
                    margin-bottom: 15px;
                    font-size: 14px;

                    label {
                        margin-bottom: 10px;
                    }

                    .table {
                        width: 100%;

                        td {
                            vertical-align: top;
                            border: 1px solid #ddd;

                            &:first-child {
                                width: 40%;
                            }

                            &:last-child {
                                width: 60%;
                            }
                        }
                    }

                    .promotion {
                        .line-through {
                            font-size: 12px;
                            text-decoration: line-through;
                            color: #ccc;

                            span {
                                color: #ccc;
                            }
                        }

                        i {
                            font-size: 11px;
                            color: #56b3a6;
                        }
                    }

                    span {
                        color: #cc0000;
                    }
                    
                    i {
                        font-size: 22px;
                        line-height: 22px;
                        @include verticalAlign(middle);
                    }
                }

                p {
                    font-size: 13px;
                    margin: 0;

                    span {
                        text-decoration: underline;
                        color: #cc0000;
                    }
                }

                .bank {
                    margin-bottom: 25px;

                    h4 {
                        font-size: 14px;
                        color: #333;
                        margin: 0;
                        padding-top: 20px;

                        &:first-child {
                            padding-top: 0;
                        }

                        i {
                            font-size: 22px;
                            line-height: 22px;
                            @include verticalAlign(middle);
                        }
                    }

                    .item {
                        font-size: 16px;
                        padding: 15px 0;
                        border-bottom: 1px dashed #ddd;

                        img, label {
                            @include verticalAlign(middle);
                            margin-right: 20px;
                        }

                        span {
                            display: block;
                            color: #999;
                            font-size: 12px;
                            padding-bottom: 10px;

                            &:after {
                                content: " ";
                                display: block;
                                width: 30px;
                                height: 1px;
                                background: #ccc;
                            }
                        }

                        @media only screen and (max-width: $screenMedium) {
                            text-align: center;

                            img {
                                display: block;
                                margin: 0 auto 10px;
                            }

                            span:after {
                                margin: auto;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>